"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedInput = exports.InlineInput = exports.UserDefinedField = exports.UDFRenderKind = exports.UDFTypeChoices = void 0;
var React = require("react");
var multiSelect_1 = require("./lib/multiSelect");
var react_datepicker_1 = require("react-datepicker");
var moment = require("moment");
var combobox_1 = require("./lib/combobox");
var accordionElement_1 = require("./riskPage/accordionElement");
exports.UDFTypeChoices = {
    "TEXT": 10,
    "NUMBER": 20,
    "TEXT_LIST": 30,
    "NUMBER_LIST": 40,
    "DATE": 70,
    "DATE_LIST": 80,
    "LINK": 90,
    "LINK_LIST": 100,
    "MATH": 110,
    "MULTIPLE": [30, 40, 80, 100],
    "SINGLE": [10, 20, 70, 90]
};
var UDFRenderKind;
(function (UDFRenderKind) {
    UDFRenderKind[UDFRenderKind["INLINE"] = 10] = "INLINE";
    UDFRenderKind[UDFRenderKind["STACKED"] = 20] = "STACKED";
    UDFRenderKind[UDFRenderKind["ACCORDION"] = 30] = "ACCORDION";
})(UDFRenderKind = exports.UDFRenderKind || (exports.UDFRenderKind = {}));
var UserDefinedField = function (props) {
    var includes_value = function (value) {
        if (!props.udf_values)
            return false;
        return props.udf_values.reduce(function (is_included, fvalue) {
            return is_included || fvalue.value == value;
        }, false);
    };
    var get_choices = function () {
        var fieldType = props.udf_type;
        if (fieldType.options == undefined || fieldType.options.length == 0)
            return [];
        var option_result = [];
        fieldType.options.split("\n").forEach(function (current_option) {
            var _a;
            var option_name = current_option, option_value = current_option;
            if (current_option.indexOf("=") != -1) {
                _a = __read(current_option.split("="), 2), option_name = _a[0], option_value = _a[1];
            }
            option_result.push({
                display_name: option_name,
                value: option_value,
                selected: includes_value(option_value)
            });
        });
        return option_result;
    };
    var get_options = function () {
        var choices = get_choices();
        var is_selection = false;
        var choice_items = choices.map(function (choice, index) {
            if (includes_value(choice.value)) {
                is_selection = true;
                return React.createElement("option", { value: choice.value, key: index, selected: true }, choice.display_name);
            }
            else {
                return React.createElement("option", { value: choice.value, key: index }, choice.display_name);
            }
        });
        if (!is_selection) {
            choice_items.splice(0, 0, React.createElement("option", { selected: true, value: "" }, gettext("(no selection)")));
        }
        else {
            choice_items.splice(0, 0, React.createElement("option", { value: "" }, gettext("(no selection)")));
        }
        return choice_items;
    };
    var get_values = function () {
        if (props.udf_values == null)
            return [];
        return props.udf_values.map(function (fvalue) {
            return sanitize(fvalue.value);
        });
    };
    var get_value = function () {
        if (props.udf_values == null)
            return null;
        return sanitize(props.udf_values.length > 0 ?
            props.udf_values[0].value : null);
    };
    var sanitize = function (value) {
        if (value == null)
            return null;
        switch (props.udf_type.type_id) {
            case exports.UDFTypeChoices.NUMBER:
                return parseInt(value);
            case exports.UDFTypeChoices.NUMBER_LIST:
                return parseInt(value);
            case exports.UDFTypeChoices.LINK:
                return parseInt(value);
            case exports.UDFTypeChoices.LINK_LIST:
                return parseInt(value);
            case exports.UDFTypeChoices.TEXT:
                return value.toString();
            case exports.UDFTypeChoices.TEXT_LIST:
                return value.toString();
            case exports.UDFTypeChoices.DATE:
                return props.udf_type.options ? value.toString()
                    : moment(value);
            case exports.UDFTypeChoices.DATE_LIST:
                return props.udf_type.options ? value.toString()
                    : moment(value);
            case exports.UDFTypeChoices.MATH:
                return value.toString();
            default:
                return value;
        }
    };
    var set_values = function (values) {
        values = values.map(function (value) { return sanitize(value); });
        var udf_values = props.udf_values.filter(function (udf_value) {
            return (values.indexOf(sanitize(udf_value.value)) != -1);
        });
        values = values.filter(function (value) {
            return !props.udf_values
                .reduce(function (is_included, fvalue) {
                return is_included || fvalue.value == value;
            }, false);
        });
        udf_values = udf_values.concat(values.map(function (value) {
            return {
                id: undefined,
                field_type: props.udf_type,
                value: value,
                target_type: props.udf_type.target_type,
                target_object_id: props.target_object_id
            };
        }));
        props.onChange(props.udf_type, udf_values);
    };
    var fieldType = props.udf_type;
    var field_name = props.udf_type.name.toLowerCase().replace(/[ "'></=]/g, "_");
    if (props.field_name_id) {
        field_name = (props.field_name_prefix || "") + props.udf_type.id;
    }
    var field_id = field_name + "_id";
    var input_html;
    if (exports.UDFTypeChoices.MULTIPLE.indexOf(fieldType.type_id) != -1) {
        input_html = (React.createElement("div", null,
            React.createElement(multiSelect_1.Multiselect, { key: props.udf_type.id, id: field_id, choices: get_choices(), value: get_values(), name: field_name, onChangeEvent: function (e) { set_values(e.currentTarget.value); }, noneSelectedText: gettext("select..."), classes: "gm--fullwidth" }),
            React.createElement("div", null, get_values().map(function (value) {
                return React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "badge badge-pill badge-secondary badge-outline text-break text-wrap text-left" }, value),
                    "\u00A0");
            }))));
    }
    else if (fieldType.type_id == exports.UDFTypeChoices.LINK) {
        input_html = (React.createElement(React.Fragment, null,
            React.createElement("input", { type: "hidden", name: field_name, id: field_id, value: get_value() }),
            React.createElement(combobox_1.ComboBox, { key: props.udf_type.id, className: "form-control", options: (0, combobox_1.choices_to_suggestions)(get_choices()), value: get_value(), onChange: function (value) { return set_values([value]); } })));
    }
    else if (exports.UDFTypeChoices.SINGLE.indexOf(fieldType.type_id) != -1 && fieldType.options) {
        input_html = (React.createElement("select", { key: props.udf_type.id, id: field_id, name: field_name, className: "form-control", onChange: function (e) {
                return set_values([e.target.value]);
            } }, get_options()));
    }
    else if (fieldType.type_id == exports.UDFTypeChoices.TEXT && !fieldType.options) {
        input_html = (React.createElement("input", { id: field_id, type: "text", className: "form-control", name: field_name, value: get_value(), placeholder: gettext("enter text"), onChange: function (e) {
                return set_values([e.target.value]);
            } }));
    }
    else if (fieldType.type_id == exports.UDFTypeChoices.NUMBER && !fieldType.options) {
        input_html = (React.createElement("input", { id: field_id, type: "number", className: "form-control", name: field_name, value: get_value(), placeholder: gettext("enter value"), onChange: function (e) {
                return set_values([e.target.value]);
            } }));
    }
    else if (fieldType.type_id == exports.UDFTypeChoices.DATE && !fieldType.options) {
        input_html = (React.createElement(react_datepicker_1.default, { key: props.udf_type.id, id: field_id, name: field_name, autoComplete: "off", className: "form-control", selected: get_value(), onChange: function (date) { return set_values([date]); }, popperModifiers: {
                flip: {
                    enabled: false
                },
                preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                }
            } }));
    }
    else if (fieldType.type_id == exports.UDFTypeChoices.MATH) {
        input_html = (React.createElement("input", { id: field_id, type: "text", className: "form-control", name: field_name, value: get_value(), readOnly: true }));
    }
    if (props.render == UDFRenderKind.STACKED) {
        return (React.createElement(exports.StackedInput, { input_id: field_id, label: fieldType.name }, input_html));
    }
    else if (props.render == UDFRenderKind.INLINE) {
        return (React.createElement(exports.InlineInput, { input_id: field_id, label: fieldType.name }, input_html));
    }
    else if (props.render == UDFRenderKind.ACCORDION) {
        return (React.createElement(accordionElement_1.AccordionElement, { id: field_name, caption: fieldType.name, isOpen: props.isOpen, containsData: get_value() !== null }, input_html));
    }
};
exports.UserDefinedField = UserDefinedField;
var InlineInput = function (props) { return (React.createElement("div", { className: "form-group row" },
    React.createElement("div", { className: "col-4" },
        React.createElement("label", { className: "UserDefinedField__Label", htmlFor: props.input_id }, props.label)),
    React.createElement("div", { className: "col-8" }, props.children))); };
exports.InlineInput = InlineInput;
var StackedInput = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("label", { htmlFor: props.input_id },
        props.label,
        ":"),
    props.children)); };
exports.StackedInput = StackedInput;
